module.exports = __webpack_public_path__ + "PlayVideo-1YmhgpT.svg";